require("./bootstrap");

// start vue-tel-input
import Vue from "vue";
import VueTelInput from "vue-tel-input";

window.Vue = require("vue");
import axios from "axios";
let token = document.head.querySelector('meta[name="csrf-token"]');

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] =
        token.getAttribute("content");
    axios.defaults.headers.common["X-CSRF-TOKEN"] =
        token.getAttribute("content");
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

Vue.use(VueTelInput, {
    validCharactersOnly: true,
    mode: "international",
    defaultCountry: "sg",
});

import ReadMore from "vue-read-more";
Vue.use(ReadMore);

Vue.use(require("vue-moment"));

import VueGtag from "vue-gtag";
// get env is staging or production from .env
const gtm = document.head
    .querySelector('meta[name="gtm"]')
    .getAttribute("content");
if (gtm) {
    Vue.use(VueGtag, {
        config: { id: gtm },
    });
} else {
    Vue.use(VueGtag, {
        config: { id: "GTM-WCK3SL2" },
    });
}

var window_height;
var window_width;
var navbar_initialized = false;
var nav_toggle;

var offCanvas = {
    sidenav: {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    },
    initSideNav: function initSideNav() {
        if (!navbar_initialized) {
            var $nav = $("nav");

            // Add the offcanvas class to the navbar if it's not initialized
            $nav.addClass("navbar-offcanvas");

            // Clone relevant navbars
            var $navtop = $nav.find(".navbar-top").first().clone(true);
            var $navbar = $nav.find(".navbar-collapse").first().clone(true);

            // Let's start with some empty vars
            var ul_content = "";
            var top_content = "";

            // Set min-height of the new sidebar to the screen height
            $navbar.css("min-height", window.screen.height);

            // Take the content of .navbar-top
            $navtop.each(function () {
                var navtop_content = $(this).html();
                top_content = top_content + navtop_content;
            });

            // Take the content of .navbar-collapse
            $navbar.children("ul").each(function () {
                var nav_content = $(this).html();
                ul_content = ul_content + nav_content;
            });

            // Wrap the new content inside an <ul>
            ul_content =
                '<ul class="navbar-nav sidebar-nav">' + ul_content + "</ul>";

            // Insert the html content into our cloned content
            $navbar.html(ul_content);
            $navtop.html(top_content);

            // Append the navbar to body,
            // and insert the content of the navicons navbar just below the logo/nav-image
            $("body").append($navbar);
            $(".nav-image").after($navtop);

            // Set the toggle-variable to the Bootstrap navbar-toggler button
            var $toggle = $(".navbar-toggler");

            // Add/remove classes on toggle and set the visiblity of the sidenav,
            // and append the overlay. Also if the user clicks the overlay,
            // the sidebar will close
            $toggle.on("click", function () {
                if (offCanvas.sidenav.sidenav_visible == 1) {
                    $("html").removeClass("nav-open");
                    offCanvas.sidenav.sidenav_visible = 0;
                    $("#overlay").remove();
                    setTimeout(function () {
                        $toggle.removeClass("toggled");
                    }, 300);
                } else {
                    setTimeout(function () {
                        $toggle.addClass("toggled");
                    }, 300);

                    // Add the overlay and make it close the sidenav on click
                    var div = '<div id="overlay"></div>';
                    $(div)
                        .appendTo("body")
                        .on("click", function () {
                            $("html").removeClass("nav-open");
                            offCanvas.sidenav.sidenav_visible = 0;
                            $("#overlay").remove();
                            setTimeout(function () {
                                $toggle.removeClass("toggled");
                            }, 300);
                        });

                    $("html").addClass("nav-open");
                    offCanvas.sidenav.sidenav_visible = 1;
                }
            });
            // Set navbar to initialized
            navbar_initialized = true;
        }
    },
};

$(document).ready(function () {
    window_width = $(window).width();

    nav_toggle = $("nav").hasClass("navbar-offcanvas") ? true : false;

    // Responsive checks
    if (window_width < 992 || nav_toggle) {
        offCanvas.initSideNav();
    }

    // Close the sidebar if the user clicks a link or a dropdown-item,
    // and close the sidebar
    $(".nav-link:not(.dropdown-toggle), .dropdown-item").on(
        "click",
        function () {
            var $toggle = $(".navbar-toggler");

            $("html").removeClass("nav-open");
            offCanvas.sidenav.sidenav_visible = 0;
            setTimeout(function () {
                $toggle.removeClass("toggled");
            }, 300);
        }
    );
});

$(window).resize(function () {
    window_width = $(window).width();

    // More responsive checks if the user resize the browser
    if (window_width < 992) {
        offCanvas.initSideNav();
    }

    if (window_width > 992 && !nav_toggle) {
        $("nav").removeClass("navbar-offcanvas");
        offCanvas.sidenav.sidenav_visible = 1;
        navbar_initialized = false;
    }
});

Vue.component("adopt", require("./components/Adopt.vue").default);

Vue.component("thankyou", require("./components/ThankYou.vue").default);

Vue.component("card", require("./components/Card.vue").default);

// STORIES PAGE
Vue.component(
    "latestnews",
    require("./components/Stories/LatestNews.vue").default
);
Vue.component(
    "newsandstories",
    require("./components/Stories/NewsAndStories.vue").default
);
// STORY PAGE
Vue.component("story", require("./components/Stories/Story.vue").default);

// INCLUDES
Vue.component(
    "featured-adoptee-banner",
    require("./components/Includes/FeaturedAdopteeBanner.vue").default
);
Vue.component(
    "relatedstories",
    require("./components/Includes/RelatedStories.vue").default
);
Vue.component(
    "gradientcoverimg",
    require("./components/Includes/GradientCoverImg.vue").default
);
Vue.component(
    "becomeaheronow",
    require("./components/Includes/BecomeAHeroNow.vue").default
);
Vue.component(
    "becomeanobserver",
    require("./components/Includes/BecomeAnObserver.vue").default
);

//AUTH
Vue.component("login", require("./components/Auth/Login.vue").default);
Vue.component("tfrlogin", require("./components/Auth/TfrLogin.vue").default);
Vue.component(
    "resetpasswordemail",
    require("./components/Auth/ResetPasswordEmail.vue").default
);
Vue.component(
    "resetpassword",
    require("./components/Auth/ResetPassword.vue").default
);
Vue.component(
    "createaccountobserver",
    require("./components/Auth/CreateAccountObserver.vue").default
);
Vue.component(
    "createaccounthero",
    require("./components/Auth/CreateAccountHero.vue").default
);
Vue.component(
    "successcreationobserver",
    require("./components/Auth/SuccessCreationObserver.vue").default
);

// USERS
Vue.component("downloads", require("./components/User/Downloads.vue").default);
Vue.component("user", require("./components/User/User.vue").default);
Vue.component(
    "latestupdatetimeline",
    require("./components/User/LatestUpdateTimeline.vue").default
);

// HOME
// Vue.component("home", require("./components/Campaigns/Tiger.vue").default);

// ABOUT
// Vue.component("about", require("./components/About/About.vue").default);

// SNARING CRISIS
Vue.component(
    "snaringcrisis",
    require("./components/SnaringCrisis/SnaringCrisis.vue").default
);
Vue.component("carousel-3d", require("vue-carousel-3d").Carousel3d);
Vue.component("slide", require("vue-carousel-3d").Slide);

const app = new Vue({
    el: "#app",
    component: [
        "adopt",
        "user",
        "card",
        "stories",
        "VuePhoneNumberInput",
        "carousel-3d",
        "slide",
        // Carousel3d,
        // Slide
    ],
    mounted() {},
});
